import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["application", "applicationStatus", "lastConsolidatedRequest"],
  _excluded2 = ["metadata"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from "moment";
import { MARK_PAGE_AS_SUBMITTED, SET_APPLICATION_DETAILS, SET_APPLICATION_VALIDATIONS, SET_CONSOLIDATED_REQUEST, SET_DISCLAIMERS, SET_RAW_APPLICATION } from "@Client/@Modules/deprecated-application/store/application-mutations";
import Err from "@Client/@Routes/error";
import Amplitude from "@Shared/@Utils/amplitude";
import { getFillOutApplicationValidations, getFillOutDisclaimers, getFillOutLocalePreference, getGuestFillOutApplication, getGuestFillOutSchema, submitFillOutApplication, updateFillOutApplication, updatePin, verifyPin } from "../api/guest-fill-out-api";
import { MARK_GUEST_FILL_OUT_APPLICATION_AS_SUBMITTED, SET_FILL_OUT_RAW_SCHEMA } from "./guest-fill-out-mutations";
import { cloneDeep } from "lodash";
export const VERIFY_PIN = "VERIFY_PIN";
export const UPDATE_PIN = "UPDATE_PIN";
export const UPDATE_GUEST_FILL_OUT_APPLICATION = "UPDATE_GUEST_FILL_OUT_APPLICATION";
export const SUBMIT_GUEST_FILL_OUT_APPLICATION = "SUBMIT_GUEST_FILL_OUT_APPLICATION";
export const LOAD_GUEST_FILL_OUT_APPLICATION_VALIDATION = "LOAD_GUEST_FILL_OUT_APPLICATION_VALIDATION";
export const LOAD_GUEST_FILL_OUT_DISCLAIMERS = "LOAD_GUEST_FILL_OUT_DISCLAIMERS";
export const LOAD_GUEST_FILL_OUT_RAW_APPLICATION = "LOAD_GUEST_FILL_OUT_RAW_APPLICATION";
export const LOAD_GUEST_FILL_OUT_RAW_SCHEMA = "LOAD_GUEST_FILL_OUT_RAW_SCHEMA";
export const LOAD_GUEST_FILL_OUT_LOCALE = "LOAD_GUEST_FILL_OUT_LOCALE";
const actions = {
  [LOAD_GUEST_FILL_OUT_RAW_APPLICATION]: async context => {
    const token = context.getters["SESSION_TOKEN"];
    const _await$getGuestFillOu = await getGuestFillOutApplication(token),
      {
        application = {},
        applicationStatus,
        lastConsolidatedRequest
      } = _await$getGuestFillOu,
      appData = _objectWithoutProperties(_await$getGuestFillOu, _excluded);
    context.commit(SET_CONSOLIDATED_REQUEST, {
      consolidatedRequest: lastConsolidatedRequest
    });
    context.commit(SET_RAW_APPLICATION, _objectSpread(_objectSpread({}, application), {}, {
      applicationStatus,
      locked: appData.locked
    }));
    context.commit(SET_APPLICATION_DETAILS, _objectSpread(_objectSpread({}, appData), {}, {
      applicationStatus,
      flow: application.flow
    }));
  },
  [LOAD_GUEST_FILL_OUT_RAW_SCHEMA]: async context => {
    const token = context.getters["SESSION_TOKEN"];
    const _await$getGuestFillOu2 = await getGuestFillOutSchema(token),
      {
        metadata
      } = _await$getGuestFillOu2,
      schema = _objectWithoutProperties(_await$getGuestFillOu2, _excluded2);
    context.commit(SET_FILL_OUT_RAW_SCHEMA, {
      schema: _objectSpread(_objectSpread({}, schema), {}, {
        metadata
      }),
      fillOutSections: context.getters["GET_FILL_OUT_SECTIONS_SCHEMA_KEYS"]
    });
  },
  [VERIFY_PIN]: async (context, {
    code
  }) => {
    try {
      const token = context.rootGetters["ApplicationStandaloneStore/SESSION_TOKEN"];
      const {
        forceChange,
        clientUsername,
        familyName,
        givenName,
        languagePreference: localeLanguage
      } = await verifyPin(token, code);
      context.commit("ApplicationStandaloneStore/SET_CLIENT_DETAILS", {
        clientDetails: {
          clientUsername,
          familyName,
          givenName
        }
      }, {
        root: true
      });
      if (localeLanguage) context.commit("AccountStore/SET_ACCOUNT_DETAILS", {
        accountDetails: {
          localeLanguage
        }
      }, {
        root: true
      });
      return {
        forceChange
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_PIN]: async (context, {
    code,
    newCode
  }) => {
    try {
      const token = context.rootGetters["ApplicationStandaloneStore/SESSION_TOKEN"];
      await updatePin(token, code, newCode);
      return true;
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_GUEST_FILL_OUT_APPLICATION]: async (context, {
    page,
    ignoreSubmitted
  }) => {
    try {
      const token = context.getters["SESSION_TOKEN"];
      if (page && !ignoreSubmitted) {
        context.commit(MARK_PAGE_AS_SUBMITTED, {
          page
        });
      }
      await updateFillOutApplication(token, cloneDeep(context.state.application));
      context.commit(SET_APPLICATION_DETAILS, {
        updatedAt: moment().format()
      });
      Amplitude.logEvent("Guest Application - application updated");
    } catch (error) {
      if (page) {
        context.commit(MARK_PAGE_AS_SUBMITTED, {
          page,
          submitted: false
        });
      }
      throw error;
    }
  },
  [SUBMIT_GUEST_FILL_OUT_APPLICATION]: async context => {
    const token = context.getters["SESSION_TOKEN"];
    await submitFillOutApplication(token);
    context.commit(MARK_GUEST_FILL_OUT_APPLICATION_AS_SUBMITTED, {});
    Amplitude.logEvent("Guest Application - application submitted");
  },
  [LOAD_GUEST_FILL_OUT_APPLICATION_VALIDATION]: async context => {
    try {
      const token = context.getters["SESSION_TOKEN"];
      const {
        errors
      } = await getFillOutApplicationValidations(token);
      context.commit(SET_APPLICATION_VALIDATIONS, {
        errors
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_GUEST_FILL_OUT_DISCLAIMERS]: async context => {
    const token = context.getters["SESSION_TOKEN"];
    const {
      disclaimers
    } = await getFillOutDisclaimers(token);
    context.commit(SET_DISCLAIMERS, {
      disclaimers
    });
  },
  [LOAD_GUEST_FILL_OUT_LOCALE]: async context => {
    try {
      const token = context.rootGetters["ApplicationStandaloneStore/SESSION_TOKEN"];
      const {
        languagePreference: localeLanguage
      } = await getFillOutLocalePreference(token);
      if (localeLanguage) context.commit("AccountStore/SET_ACCOUNT_DETAILS", {
        accountDetails: {
          localeLanguage
        }
      }, {
        root: true
      });
    } catch (e) {
      Err.handle(e);
    }
  }
};
export default actions;